<template>
  <router-view class="label page" />
</template>

<script>
export default {}
</script>

<style lang="css" scoped src="./label.css"></style>
